import { cartTotalStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

cartTotalStyles.placeOrderButton = {
    variant: "primary",
    css: css`
        border-radius: 2px;
        margin-top: 20px;
        span[class^="TypographyStyle"] {
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            width: 100%;
            height: 48px;
            font-weight: 600;
            font-size: 16px;
        }
        width: 100%;
        height: 48px;
        font-weight: 600;
        font-size: 16px;
    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
            width: 100%;
          `,
                    css`
            width: 100%;
          `,
                ],
                "min",
            )}
    `,
};
cartTotalStyles.cartTotalGridItem = {
    width: 12,
    css: css`
        > div {
            padding: 25px 30px 18px !important;
            background: ${COLORS.checkout.lightBg};
        }
    `,
};
